import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";
import { PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";
import { LogisticsDetails } from "components/Logistics/Pickups/LogisticsInfo/LogisticsDetails";
import useLogisticsDetails from "hooks/useLogisticsDetails";

export const LogisticsDetailsPage = () => {
  const { logisticsPickup } = useLogisticsDetails();
  return (
    <AutoPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Logistics" }, { label: "Pickups", path: "/logistics" }]} />
      <PageTitle>Pickup {logisticsPickup?.id}</PageTitle>
      <LogisticsDetails />
    </AutoPagePaperLayout>
  );
};
